import { createSelector } from '@reduxjs/toolkit';

import { createBankAccountItems } from '_helpers/bankAccounts';

export const selectData = (state) => state.bankAccounts.data;
export const selectError = (state) => state.bankAccounts.error;
export const selectLoading = (state) => state.bankAccounts.loading;
export const selectAdding = (state) => state.bankAccounts.adding;
export const selectDeleting = (state) => state.bankAccounts.deleting;

export const selectBankAccountItems = createSelector([selectData], (bankAccounts) => {
  return createBankAccountItems(bankAccounts);
});

export const selectBankAccountItemById = (id) =>
  createSelector([selectBankAccountItems], (bankAccountItems) => {
    return bankAccountItems.find((item) => item.id === id);
  });
